import request from "@/lib/util/request";
import {AccessToken} from "@/lib/type/login-register.type";
import {MyOrderResponse, MyOrderResponseType, OrderNowBodyType, SuccessOrderResponseType} from "@/lib/type/myOrder";

// 获取订单总数
export const requestGetOrderCount = (params?: AccessToken) => request<number>({
    endpoint: "/api/tiny-shop/v1/member/order/count",
    method: "GET",
    params
});

//获取我的所有订单
export const requestGetMyOrder = (params: {"access-token": string,page?:string,limit?:string,order_status?:string}) => request<MyOrderResponse>({
    endpoint: `/api/tiny-shop/v1/member/order/index`,
    method: "GET",
    params
});


// 取消订单
export const requestCancelOrder = (params:{"access-token": string,id:string}) => request<MyOrderResponseType[]>({
    endpoint: `/api/tiny-shop/v1/member/order/close`,
    method: "POST",
    params
});


//立即下单
export const requestOrderNow = (params:AccessToken,body:OrderNowBodyType) => request<SuccessOrderResponseType>({
    endpoint: `/api/tiny-shop/v1/order/order/create`,
    method: "POST",
    params,
    body
});

//单个订单详情
export const requestOrderDetail = (params:{"access-token": string,id:string}) => request<MyOrderResponseType>({
    endpoint: `/api/tiny-shop/v1/member/order/view`,
    method: "GET",
    params,
});

